import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * 注意：子菜单仅在route children.length>=1时出现
 * 详情见: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   如果设置为true，则项目将不会显示在侧边栏中（默认为false）
 * alwaysShow: true               如果设置为true，将始终显示根菜单
 *                                如果不始终设置Show，则当项具有多个子路由时
 *                                它将成为嵌套模式，否则不显示根菜单
 * redirect: noRedirect           如果设置noRedirect，则不会在breadcrumb中重定向
 * name:'router-name'             名称由<keep alive>使用（必须设置！！！）
 * meta : {
    roles: ['admin','editor']    控制页面角色（可以设置多个角色）
    title: 'title'               侧边栏和面包屑中显示的名称（推荐集）
    icon: 'svg-name'             图标显示在侧栏中
    breadcrumb: false            如果设置为false，则该项将隐藏在breadcrumb中（默认为true）
    activeMenu: '/example/list'  如果设置路径，侧边栏将突出显示您设置的路径
  }
 */

/**
 * constantRoutes
 * 没有权限要求的基页
 * 可以访问所有角色
 */
export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/welcome',
    hidden: true,
    children: [{
      path: 'welcome',
      name: 'welcome',
      component: () => import('@/views/welcome/index'),
      meta: {
        title: '控制台'
      },
    }]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/preRecordReportMonthDetailNew',
    component: () => import('@/views/preTraining/preRecord/preRecordReportMonthDetailNew'),
    hidden: true,
  },
  {
    path: '/accountReportMonthDetailNew',
    component: () => import('@/views/authority/account/accountReportMonthDetailNew'),
    hidden: true,
  },
  {
    path: '/accountThirdPartyRecordDetail',
    hidden: true,
    component: () => import('@/views/authority/account/accountThirdPartyRecordDetail'),
  },
  {
    path: '/studyCertificate',
    component: () => import('@/views/studyCertificate/index'),
    hidden: true,
    meta: {
      title: '学习证书'
    }
  },
  {
    path: '/personal/editPwd',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'editPwd',//这个必须和页面name对应起来
      component: () => import('@/views/personal/editPwd'),
      meta: {
        title: '修改密码'
      }
    }]
  },
  {
    path: '/authority/car/carLearningReport',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'carLearningReport',//这个必须和页面name对应起来
      component: () => import('@/views/authority/car/carLearningReport'),
      meta: {
        title: '学习报表',
        activeMenu: "/authority/car",
        parent: {name: "car"},
        keepAlive: true,
      }
    }]
  },
  {
    path: '/authority/car/carLearningReportDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'carLearningReportDetail',//这个必须和页面name对应起来
      component: () => import('@/views/authority/car/carLearningReportDetail'),
      meta: {
        title: '学习报表详情',
        activeMenu: "/authority/car",
        parent: {name: "car"}
      }
    }]
  },
  {
    path: '/authority/account/accountAdd',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'accountAdd',//这个必须和页面name对应起来
      component: () => import('@/views/authority/account/accountAdd'),
      meta: {
        title: '添加账号',
        activeMenu: "/authority/account",
        parent: {name: "account"}
      }
    }]
  },
  {
    path: '/authority/account/accountEdit',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'accountEdit',//这个必须和页面name对应起来
      component: () => import('@/views/authority/account/accountEdit'),
      meta: {
        title: '编辑账号',
        activeMenu: "/authority/account",
        parent: {name: "account"}
      }
    }]
  },
  {
    path: '/authority/account/accountAdminEdit',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'accountAdminEdit',//这个必须和页面name对应起来
      component: () => import('@/views/authority/account/accountAdminEdit'),
      meta: {
        title: '管理员编辑账号',
        activeMenu: "/authority/account",
        parent: {name: "account"}
      }
    }]
  },
  {
    path: '/authority/account/accountRecord',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'accountRecord',//这个必须和页面name对应起来
      component: () => import('@/views/authority/account/accountRecord'),
      meta: {
        title: '学习记录',
        activeMenu: "/authority/account",
        parent: {name: "account"},
        keepAlive: true
      }
    }]
  },
  {
    path: '/authority/account/accountRecordDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'accountRecordDetail',//这个必须和页面name对应起来
      component: () => import('@/views/authority/account/accountRecordDetail'),
      meta: {
        title: '学习记录详情',
        activeMenu: "/authority/account",
        parent: {name: "account"}
      }
    }]
  },
  {
    path: '/authority/account/accountReport',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'accountReport',//这个必须和页面name对应起来
      component: () => import('@/views/authority/account/accountReport'),
      meta: {
        title: '学习报表',
        activeMenu: "/authority/account",
        parent: {name: "account"},
        keepAlive: true
      }
    }]
  },
  {
    path: '/authority/account/accountReportMonthDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'accountReportMonthDetail',//这个必须和页面name对应起来
      component: () => import('@/views/authority/account/accountReportMonthDetail'),
      meta: {
        title: '学习报表详情',
        activeMenu: "/authority/account",
        parent: {name: "account"}
      }
    }]
  },
  {
    path: '/authority/account/accountChangeEnp',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'accountChangeEnp',//这个必须和页面name对应起来
      component: () => import('@/views/authority/account/accountChangeEnp'),
      meta: {
        title: '变更企业',
        activeMenu: "/authority/account",
        parent: {name: "account"}
      }
    }]
  },
  {
    path: '/authority/enpAccount/enpAccountAdd',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'enpAccountAdd',//这个必须和页面name对应起来
      component: () => import('@/views/authority/enpAccount/enpAccountAdd'),
      meta: {
        title: '新增',
        activeMenu: "/authority/enpAccount",
        parent: {name: "enpAccount"}
      }
    }]
  },
  {
    path: '/authority/enpAccount/enpAccountEdit',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'enpAccountEdit',//这个必须和页面name对应起来
      component: () => import('@/views/authority/enpAccount/enpAccountEdit'),
      meta: {
        title: '编辑',
        activeMenu: "/authority/enpAccount",
        parent: {name: "enpAccount"}
      }
    }]
  },
  {
    path: '/authority/enterprise/enterpriseAdd',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'enterpriseAdd',//这个必须和页面name对应起来
      component: () => import('@/views/authority/enterprise/enterpriseAdd'),
      meta: {
        title: '新增',
        activeMenu: "/authority/enterprise",
        parent: {name: "enterprise"}
      }
    }]
  },
  {
    path: '/authority/enterprise/enterpriseEdit',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'enterpriseEdit',//这个必须和页面name对应起来
      component: () => import('@/views/authority/enterprise/enterpriseEdit'),
      meta: {
        title: '编辑',
        activeMenu: "/authority/enterprise",
        parent: {name: "enterprise"}
      }
    }]
  },
  {
    path: '/authority/periodRecord/pushRecord', // 推送记录
    hidden: true,
    component: Layout, // 菜单组件
    children: [{
      path: '/',
      name: 'pushRecord',//这个必须和页面name对应起来
      component: () => import('@/views/authority/periodRecord/pushRecord'),
      meta: {
        title: '推送记录',
        activeMenu: "/authority/periodRecord",
        parent: {name: "periodRecord"}
      }
    }]
  },
  {
    path: '/msg/msgRecord',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'msgRecord',//这个必须和页面name对应起来
      component: () => import('@/views/msg/msgRecord'),
      meta: {
        title: '阅读记录',
        activeMenu: '/msg',
        parent: {name: 'msg'}
      }
    }]
  },
  {
    path: '/policy/list/policyFeedback',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'policyFeedback',//这个必须和页面name对应起来
      component: () => import('@/views/policy/list/policyFeedback'),
      meta: {
        title: '反馈记录',
        activeMenu: '/policy/policy',
        parent: {name: 'policy'}
      }
    }]
  },
  {
    path: '/policy/list/policyRecord',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'policyRecord',//这个必须和页面name对应起来
      component: () => import('@/views/policy/list/policyRecord'),
      meta: {
        title: '阅读记录',
        activeMenu: '/policy/policy',
        parent: {name: 'policy'}
      }
    }]
  },
  {
    path: '/trainBasic/courseware/coursewareAdd',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'coursewareAdd',//这个必须和页面name对应起来
      component: () => import('@/views/trainBasic/courseware/coursewareAdd'),
      meta: {
        title: '课题库新增',
        activeMenu: '/trainBasic/courseware',
        parent: {name: 'courseware'}
      }
    }]
  },
  {
    path: '/trainBasic/courseware/coursewareEdit',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'coursewareEdit',//这个必须和页面name对应起来
      component: () => import('@/views/trainBasic/courseware/coursewareEdit'),
      meta: {
        title: '课题库编辑',
        activeMenu: '/trainBasic/courseware',
        parent: {name: 'courseware'}
      }
    }]
  },
  {
    path: '/trainBasic/courseware/coursewareDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'coursewareDetail',//这个必须和页面name对应起来
      component: () => import('@/views/trainBasic/courseware/coursewareDetail'),
      meta: {
        title: '课题库详情',
        activeMenu: '/trainBasic/courseware',
        parent: {name: 'courseware'}
      }
    }]
  },
  {
    path: '/trainBasic/course/bindCourseware',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'bindCourseware',//这个必须和页面name对应起来
      component: () => import('@/views/trainBasic/course/bindCourseware'),
      meta: {
        title: '课件',
        activeMenu: '/trainBasic/course',
        parent: {name: 'course'},
        keepAlive: true
      }
    }]
  },
  {
    path: '/trainBasic/course/courseDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'courseDetail',//这个必须和页面name对应起来
      component: () => import('@/views/trainBasic/course/courseDetail'),
      meta: {
        title: '课件详情',
        activeMenu: '/trainBasic/course',
        parent: {name: 'course'}
      }
    }]
  },
  {
    path: '/trainBasic/course/courseReleaseDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'courseReleaseDetail',//这个必须和页面name对应起来
      component: () => import('@/views/trainBasic/course/courseReleaseDetail'),
      meta: {
        title: '课程详情',
        activeMenu: '/trainBasic/course',
        parent: {name: 'course'},
        keepAlive: true
      }
    }]
  },
  {
    path: '/trainBasic/course/courseTestPaperRules',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'courseTestPaperRules',//这个必须和页面name对应起来
      component: () => import('@/views/trainBasic/course/courseTestPaperRules'),
      meta: {
        title: '组卷规则',
        activeMenu: '/trainBasic/course',
        parent: {name: 'course'}
      }
    }]
  },
  {
    path: '/trainBasic/questionBank/questionBankAdd',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'questionBankAdd',//这个必须和页面name对应起来
      component: () => import('@/views/trainBasic/questionBank/questionBankAdd'),
      meta: {
        title: '题库新增',
        activeMenu: '/trainBasic/questionBank',
        parent: {name: 'questionBank'}
      }
    }]
  },
  {
    path: '/trainBasic/questionBank/questionBankDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'questionBankDetail',//这个必须和页面name对应起来
      component: () => import('@/views/trainBasic/questionBank/questionBankDetail'),
      meta: {
        title: '题库详情',
        activeMenu: '/trainBasic/questionBank',
        parent: {name: 'questionBank'}
      }
    }]
  },
  {
    path: '/trainBasic/questionBank/questionBankEdit',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'questionBankEdit',//这个必须和页面name对应起来
      component: () => import('@/views/trainBasic/questionBank/questionBankEdit'),
      meta: {
        title: '题库编辑',
        activeMenu: '/trainBasic/questionBank',
        parent: {name: 'questionBank'}
      }
    }]
  },

  {
    path: '/examEmployees/questionBankManagement/questionBankEmpAdd',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'questionBankEmpAdd',//这个必须和页面name对应起来
      component: () => import('@/views/examEmployees/questionBankManagement/questionBankAdd'),
      meta: {
        title: '题库新增',
        activeMenu: '/examEmployees/questionBankManagement',
        parent: {name: 'questionBankManagementEmp'}
      }
    }]
  },
  {
    path: '/examEmployees/questionBankManagement/questionBankEmpDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'questionBankEmpDetail',//这个必须和页面name对应起来
      component: () => import('@/views/examEmployees/questionBankManagement/questionBankDetail'),
      meta: {
        title: '题库详情',
        activeMenu: '/examEmployees/questionBankManagement',
        parent: {name: 'questionBankManagementEmp'}
      }
    }]
  },
  {
    path: '/examEmployees/questionBankManagement/questionBankEmpEdit',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'questionBankEmpEdit',//这个必须和页面name对应起来
      component: () => import('@/views/examEmployees/questionBankManagement/questionBankEdit'),
      meta: {
        title: '题库编辑',
        activeMenu: '/examEmployees/questionBankManagement',
        parent: {name: 'questionBankManagementEmp'}
      }
    }]
  },


  {
    path: '/safety/plan/planTestSet',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'planTestSet',//这个必须和页面name对应起来
      component: () => import('@/views/safety/plan/planTestSet'),
      meta: {
        title: '试卷设置',
        activeMenu: '/safety/plan',
        parent: {name: 'plan'}
      }
    }]
  },
  {
    path: '/safety/plan/chooseTrainCourse',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'chooseTrainCourse',//这个必须和页面name对应起来
      component: () => import('@/views/safety/plan/chooseTrainCourse'),
      meta: {
        title: '选取培训课程',
        activeMenu: '/safety/plan',
        parent: {name: 'plan'}
      }
    }]
  },
  {
    path: '/safety/plan/customCourse',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'customCourse',//这个必须和页面name对应起来
      component: () => import('@/views/safety/plan/customCourse'),
      meta: {
        title: '课程',
        activeMenu: '/safety/plan',
        parent: {name: 'plan'},
        keepAlive: true
      }
    }]
  },
  {
    path: '/safety/plan/planCourseDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'planCourseDetail',//这个必须和页面name对应起来
      component: () => import('@/views/safety/plan/planCourseDetail'),
      meta: {
        title: '课程详情',
        activeMenu: '/safety/plan',
        parent: {name: 'plan'}
      }
    }]
  },
  {
    path: '/safety/plan/planReleaseDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'planReleaseDetail',//这个必须和页面name对应起来
      component: () => import('@/views/safety/plan/planReleaseDetail'),
      meta: {
        title: '课件详情',
        activeMenu: '/safety/plan',
        parent: {name: 'plan'},
        keepAlive: true
      }
    }]
  },
  {
    path: '/safety/plan/planTestPaperRules',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'planTestPaperRules',//这个必须和页面name对应起来
      component: () => import('@/views/safety/plan/planTestPaperRules'),
      meta: {
        title: '组卷规则',
        activeMenu: '/safety/plan',
        parent: {name: 'plan'}
      }
    }]
  },
  {
    path: '/safety/report/reportYearDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'reportYearDetail',//这个必须和页面name对应起来
      component: () => import('@/views/safety/report/reportYearDetail'),
      meta: {
        title: '年度报表详情',
        activeMenu: '/safety/report',
        parent: {name: 'report'}
      }
    }]
  },
  {
    path: '/safety/report/reportMonthDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'reportMonthDetail',//这个必须和页面name对应起来
      component: () => import('@/views/safety/report/reportMonthDetail'),
      meta: {
        title: '月报表详情',
        activeMenu: '/safety/report',
        parent: {name: 'report'}
      }
    }]
  },
  {
    path: '/safety/train/trainHistory',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'trainHistory',//这个必须和页面name对应起来
      component: () => import('@/views/safety/train/trainHistory'),
      meta: {
        title: '历史统计',
        activeMenu: '/safety/train',
        parent: {name: 'train'},
        keepAlive: true
      }
    }]
  },
  {
    path: '/safety/train/trainIncomplete',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'trainIncomplete',//这个必须和页面name对应起来
      component: () => import('@/views/safety/train/trainIncomplete'),
      meta: {
        title: '未完成人数',
        activeMenu: '/safety/train',
        parent: {name: 'train'},
        keepAlive: true
      }
    }]
  },
  {
    path: '/safety/train/trainCompleted',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'trainCompleted',//这个必须和页面name对应起来
      component: () => import('@/views/safety/train/trainCompleted'),
      meta: {
        title: '已完成人数',
        activeMenu: '/safety/train',
        parent: {name: 'train'},
        keepAlive: true
      }
    }]
  },
  {
    path: '/safety/train/trainInRecord',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'trainInRecord',//这个必须和页面name对应起来
      component: () => import('@/views/safety/train/trainInRecord'),
      meta: {
        title: '学习记录',
        activeMenu: '/safety/train',
        parent: {name: 'train'}
      }
    }]
  },
  {
    path: '/safety/train/trainInReport',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'trainReport',//这个必须和页面name对应起来
      component: () => import('@/views/safety/train/trainInReport'),
      meta: {
        title: '学习报表',
        activeMenu: "/safety/train",
        parent: {name: "train"},
        keepAlive: true
      }
    }]
  },
  {
    path: '/safety/train/trainInReportMonthDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'trainInReportMonthDetail',//这个必须和页面name对应起来
      component: () => import('@/views/safety/train/trainInReportMonthDetail'),
      meta: {
        title: '学习报表详情',
        activeMenu: "/safety/train",
        parent: {name: "train"}
      }
    }]
  },
  {
    path: '/safety/train/trainStatStaff',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'trainStatStaff',//这个必须和页面name对应起来
      component: () => import('@/views/safety/train/trainStatStaff'),
      meta: {
        title: '人员统计详情',
        activeMenu: "/safety/train",
        parent: {name: "train"}
      }
    }]
  },
  {
    path: '/safety/offline/offlineAdd',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'offlineAdd',//这个必须和页面name对应起来
      component: () => import('@/views/safety/offline/offlineAdd'),
      meta: {
        title: '新增',
        activeMenu: "/safety/offline",
        parent: {name: "offline"}
      }
    }]
  },
  {
    path: '/safety/offline/offlineEdit',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'offlineEdit',//这个必须和页面name对应起来
      component: () => import('@/views/safety/offline/offlineEdit'),
      meta: {
        title: '编辑',
        activeMenu: "/safety/offline",
        parent: {name: "offline"}
      }
    }]
  },
  {
    path: '/safety/offline/offlineDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'offlineDetail',//这个必须和页面name对应起来
      component: () => import('@/views/safety/offline/offlineDetail'),
      meta: {
        title: '详情',
        activeMenu: "/safety/offline",
        parent: {name: "offline"}
      }
    }]
  },
  {
    path: '/safety/trainingSyllabus/syllabusAdd',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'syllabusAdd',//这个必须和页面name对应起来
      component: () => import('@/views/safety/trainingSyllabus/syllabusAdd'),
      meta: {
        title: '培训大纲',
        activeMenu: "/safety/trainingSyllabus",
        parent: {name: "trainingSyllabus"}
      }
    }]
  },
  {
    path: '/preTraining/curriculum/curriculumTestSet',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'curriculumTestSet',//这个必须和页面name对应起来
      component: () => import('@/views/preTraining/curriculum/curriculumTestSet'),
      meta: {
        title: '试卷设置',
        activeMenu: "/preTraining/curriculum",
        parent: {name: "curriculum"}
      }
    }]
  },
  {
    path: '/preTraining/curriculum/curriculumChooseCourse',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'curriculumChooseCourse',//这个必须和页面name对应起来
      component: () => import('@/views/preTraining/curriculum/curriculumChooseCourse'),
      meta: {
        title: '选取课程包',
        activeMenu: "/preTraining/curriculum",
        parent: {name: "curriculum"}
      }
    }]
  },
  {
    path: '/preTraining/curriculum/curriculumCustomCourse',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'curriculumCustomCourse',//这个必须和页面name对应起来
      component: () => import('@/views/preTraining/curriculum/curriculumCustomCourse'),
      meta: {
        title: '课件',
        activeMenu: "/preTraining/curriculum",
        parent: {name: "curriculum"},
        keepAlive: true
      }
    }]
  },
  {
    path: '/preTraining/curriculum/curriculumCourseDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'curriculumCourseDetail',//这个必须和页面name对应起来
      component: () => import('@/views/preTraining/curriculum/curriculumCourseDetail'),
      meta: {
        title: '课程详情',
        activeMenu: "/preTraining/curriculum",
        parent: {name: "curriculum"}
      }
    }]
  },
  {
    path: '/preTraining/curriculum/curriculumReleaseDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'curriculumReleaseDetail',//这个必须和页面name对应起来
      component: () => import('@/views/preTraining/curriculum/curriculumReleaseDetail'),
      meta: {
        title: '课程详情',
        activeMenu: "/preTraining/curriculum",
        parent: {name: "curriculum"},
        keepAlive: true
      }
    }]
  },
  {
    path: '/preTraining/curriculum/curriculumTestPaperRules',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'curriculumTestPaperRules',//这个必须和页面name对应起来
      component: () => import('@/views/preTraining/curriculum/curriculumTestPaperRules'),
      meta: {
        title: '组卷规则',
        activeMenu: "/preTraining/curriculum",
        parent: {name: "curriculum"}
      }
    }]
  },
  {
    path: '/preTraining/preRecord/preRecordDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'preRecordDetail',//这个必须和页面name对应起来
      component: () => import('@/views/preTraining/preRecord/preRecordDetail'),
      meta: {
        title: '详情',
        activeMenu: "/preTraining/preRecord",
        parent: {name: "preRecord"},
        keepAlive: true
      }
    }]
  },
  {
    path: '/preTraining/preRecord/preRecordDetailStudy',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'preRecordDetailStudy',//这个必须和页面name对应起来
      component: () => import('@/views/preTraining/preRecord/preRecordDetailStudy'),
      meta: {
        title: '学习记录详情',
        activeMenu: "/preTraining/preRecord",
        parent: {name: "preRecord"}
      }
    }]
  },
  {
    path: '/preTraining/preRecord/preRecordDetailReport',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'preRecordDetailReport',//这个必须和页面name对应起来
      component: () => import('@/views/preTraining/preRecord/preRecordDetailReport'),
      meta: {
        title: '学习报表',
        activeMenu: "/preTraining/preRecord",
        parent: {name: "preRecord"},
        keepAlive: true
      }
    }]
  },
  {
    path: '/preTraining/preRecord/preRecordReportMonthDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'preRecordReportMonthDetail',//这个必须和页面name对应起来
      component: () => import('@/views/preTraining/preRecord/preRecordReportMonthDetail'),
      meta: {
        title: '学习报表详情',
        activeMenu: "/preTraining/preRecord",
        parent: {name: "preRecord"}
      }
    }]
  },
  {
    path: '/towStaffTestQuestions/testQuestions/testQuestionsAdd',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'testQuestionsAdd',//这个必须和页面name对应起来
      component: () => import('@/views/towStaffTestQuestions/testQuestions/testQuestionsAdd'),
      meta: {
        title: '两类人员安全考试模拟题添加',
        activeMenu: "/towStaffTestQuestions/testQuestions",
        parent: {name: "preRecord"}
      }
    }]
  },
  {
    path: '/towStaffTestQuestions/testQuestions/testQuestionsDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'testQuestionsDetail',//这个必须和页面name对应起来
      component: () => import('@/views/towStaffTestQuestions/testQuestions/testQuestionsDetail'),
      meta: {
        title: '两类人员安全考试模拟题详情',
        activeMenu: "/towStaffTestQuestions/testQuestions",
        parent: {name: "preRecord"}
      }
    }]
  },
  {
    path: '/towStaffTestQuestions/testQuestions/testQuestionsEdit',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'testQuestionsEdit',//这个必须和页面name对应起来
      component: () => import('@/views/towStaffTestQuestions/testQuestions/testQuestionsEdit'),
      meta: {
        title: '两类人员安全考试模拟题编辑',
        activeMenu: "/towStaffTestQuestions/testQuestions",
        parent: {name: "preRecord"}
      }
    }]
  },
  {
    path: '/safety/examine/examineDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'examineDetail',//这个必须和页面name对应起来
      component: () => import('@/views/safety/examine/examineDetail'),
      meta: {
        title: '考试报表详情',
        activeMenu: "/safety/examine",
        parent: {name: "examine"}
      }
    }]
  },
  {
    path: '/contract/contractAdd',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'contractAdd',//这个必须和页面name对应起来
      component: () => import('@/views/contract/list/contractAdd'),
      meta: {
        title: '合同协议新增',
        activeMenu: "/contract",
        parent: {name: "contract"}
      }
    }]
  },
  {
    path: '/contract/contractEdit',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'contractEdit',//这个必须和页面name对应起来
      component: () => import('@/views/contract/list/contractEdit'),
      meta: {
        title: '合同协议编辑',
        activeMenu: "/contract",
        parent: {name: "contract"}
      }
    }]
  },
  {
    path: '/contract/contractDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'contractDetail',//这个必须和页面name对应起来
      component: () => import('@/views/contract/list/contractDetail'),
      meta: {
        title: '合同协议详情',
        activeMenu: "/contract",
        parent: {name: "contract"}
      }
    }]
  },
  {
    path: '/contract/contractSignList',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'contractSignList',//这个必须和页面name对应起来
      component: () => import('@/views/contract/list/contractSignList'),
      meta: {
        title: '合同协议下发列表',
        activeMenu: "/contract",
        parent: {name: "contract"}
      }
    }]
  },
  {
    path: '/finance/open/openDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'openDetail',//这个必须和页面name对应起来
      component: () => import('@/views/finance/open/openDetail'),
      meta: {
        title: '开通记录明细',
        activeMenu: "/finance/open",
        parent: {name: "/finance"}
      }
    }]
  },
  {
    path: '/approve/setProcess/processConfig',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'processConfig',//这个必须和页面name对应起来
      component: () => import('@/views/approve/setProcess/processConfig'),
      meta: {
        title: '设置流程',
        activeMenu: "/approve/setProcess",
        parent: {name: "/approve"}
      }
    }]
  },
  {
    path: '/approve/processReview/processReviewInitiation',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'processReviewInitiation',//这个必须和页面name对应起来
      component: () => import('@/views/approve/processReview/processReviewInitiation'),
      meta: {
        title: '发起流程',
        activeMenu: "/approve/processReview",
        parent: {name: "/approve"}
      }
    }]
  },
  {
    path: '/approve/processReview/processReviewDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'processReviewDetail',//这个必须和页面name对应起来
      component: () => import('@/views/approve/processReview/processReviewDetail'),
      meta: {
        title: '审批详情',
        activeMenu: "/approve/processReview",
        parent: {name: "/approve"}
      }
    }]
  },
  {
    path: '/approve/approvalRecord/approvalRecordDetail',
    hidden: true,
    component: Layout, //菜单组件
    children: [{
      path: '/',
      name: 'approvalRecordDetail',//这个必须和页面name对应起来
      component: () => import('@/views/approve/approvalRecord/approvalRecordDetail'),
      meta: {
        title: '审批记录详情',
        activeMenu: "/approve/approvalRecord",
        parent: {name: "/approve"}
      }
    },

    // 专项学习

    {
      path: '/specializedLearning/specializedLearning/learnPriceSet',
      hidden: true,
      component: () => import('@/views/specializedLearning/specializedLearning/learnPriceSet'),
      children: [{
        path: '/',
        name: 'learnPriceSet',//这个必须和页面name对应起来
        meta: {
          title: '价格设置',
          activeMenu: "/specializedLearning/specializedLearning",
          parent: {name: "specializedLearning"},
        }
      }]
    },
    {
      path: '/specializedLearning/specializedLearning/learnReleaseDetail',
      hidden: true,
      component: () => import('@/views/specializedLearning/specializedLearning/learnReleaseDetail'),
      children: [{
        path: '/',
        name: 'learnReleaseDetail',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/specializedLearning/learnReleaseDetail'),

        meta: {
          title: '课件详情',
          activeMenu: "/specializedLearning/specializedLearning",
          parent: {name: "specializedLearning"},
        }
      }]
    },
    {
      path: '/specializedLearning/specializedLearning/chooseLearningObj',
      hidden: true,
      component: () => import('@/views/specializedLearning/specializedLearning/chooseLearningObj'),
      children: [{
        path: '/',
        name: 'chooseLearningObj',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/specializedLearning/chooseLearningObj'),

        meta: {
          title: '选择学习对象',
          activeMenu: "/specializedLearning/specializedLearning",
          parent: {name: "specializedLearning"},
        }
      }]
    },
    {
      path: '/specializedLearning/specializedLearning/curriculumChooseCourse',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/specializedLearning/curriculumChooseCourse'),
      children: [{
        path: '/',
        name: 'specialChooseCourse',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/specializedLearning/curriculumChooseCourse'),
        meta: {
          title: '选取课程包',
          activeMenu: "/specializedLearning/specializedLearning",
          parent: {name: "specializedLearning"}
        }
      }]
    },
    {
      path: '/specializedLearning/specializedLearning/curriculumCustomCourse',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/specializedLearning/curriculumCustomCourse'),
      children: [{
        path: '/',
        name: 'specialCustomCourse',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/specializedLearning/curriculumCustomCourse'),
        meta: {
          title: '课件',
          activeMenu: "/specializedLearning/specializedLearning",
          parent: {name: "specializedLearning"},
          keepAlive: true
        }
      }]
    },

    {
      path: '/specializedLearning/specializedLearning/curriculumCourseDetail',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/specializedLearning/curriculumCourseDetail'),
      children: [{
        path: '/',
        name: 'learnCourseDetail',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/specializedLearning/curriculumCourseDetail'),
        meta: {
          title: '课程详情',
          activeMenu: "/specializedLearning/specializedLearning",
          parent: {name: "specializedLearning"}
        }
      }]
    },
    {
      path: '/specializedLearning/specializedLearning/curriculumTestPaperRules',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/specializedLearning/curriculumTestPaperRules'),
      children: [{
        path: '/',
        name: 'learnTestPaperRules',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/specializedLearning/curriculumTestPaperRules'),
        meta: {
          title: '组卷规则',
          activeMenu: '/specializedLearning/specializedLearning',
          parent: {name: 'specializedLearning'}
        }
      }]
    },

    // 违章学习  illegalLearning
    {
      path: '/specializedLearning/illegalLearning/learnReleaseDetail',
      hidden: true,
      component: () => import('@/views/specializedLearning/illegalLearning/learnReleaseDetail'),
      children: [{
        path: '/',
        name: 'illegalReleaseDetail',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/illegalLearning/learnReleaseDetail'),

        meta: {
          title: '课件详情',
          activeMenu: "/illegalLearning/illegalLearning",
          parent: {name: "illegalLearning"},
        }
      }]
    },
    {
      path: '/specializedLearning/illegalLearning/chooseLearningObj',
      hidden: true,
      component: () => import('@/views/specializedLearning/illegalLearning/chooseLearningObj'),
      children: [{
        path: '/',
        name: 'chooseIllegalLearningObj',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/illegalLearning/chooseLearningObj'),
        meta: {
          title: '选择学习对象',
          activeMenu: "/illegalLearning/illegalLearning",
          parent: {name: "illegalLearning"},
        }
      }]
    },
    {
      path: '/specializedLearning/illegalLearning/curriculumChooseCourse',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/illegalLearning/curriculumChooseCourse'),
      children: [{
        path: '/',
        name: 'illegalChooseCourse',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/illegalLearning/curriculumChooseCourse'),
        meta: {
          title: '选取课程包',
          activeMenu: "/illegalLearning/illegalLearning",
          parent: {name: "illegalLearning"}
        }
      }]
    },
    {
      path: '/specializedLearning/illegalLearning/curriculumCustomCourse',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/illegalLearning/curriculumCustomCourse'),
      children: [{
        path: '/',
        name: 'illegalCustomCourse',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/illegalLearning/curriculumCustomCourse'),
        meta: {
          title: '课件',
          activeMenu: "/illegalLearning/illegalLearning",
          parent: {name: "illegalLearning"},
          keepAlive: true
        }
      }]
    },
    {
      path: '/specializedLearning/illegalLearning/curriculumCourseDetail',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/illegalLearning/curriculumCourseDetail'),

      children: [{
        path: '/',
        name: 'illegalCourseDetail',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/illegalLearning/curriculumCourseDetail'),
        meta: {
          title: '课程详情',
          activeMenu: "/illegalLearning/illegalLearning",
          parent: {name: "illegalLearning"}
        }
      }]
    },
    {
      path: '/specializedLearning/illegalLearning/curriculumTestPaperRules',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/illegalLearning/curriculumTestPaperRules'),
      children: [{
        path: '/',
        name: 'illegalTestPaperRules',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/illegalLearning/curriculumTestPaperRules'),
        meta: {
          title: '组卷规则',
          activeMenu: '/illegalLearning/illegalLearning',
          parent: {name: 'illegalLearning'}
        }
      }]
    },

    {
      path: '/specializedLearning/specialRecord/specialRecordCo',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/specialRecord/specialRecordCo'),
      children: [{
        path: '/',
        name: 'specialRecordCo',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/specialRecord/specialRecordCo'),
        meta: {
          title: '专项学习记录-企业',
          activeMenu: '/specializedLearning/specialRecord',
          parent: {name: 'specialRecord'}
        }
      }]
    },
    {
      path: '/specializedLearning/specialRecord/specialReportCo',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/specialRecord/specialReportCo'),
      children: [{
        path: '/',
        name: 'specialReportCo',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/specialRecord/specialReportCo'),
        meta: {
          title: '学习报表-企业',
          activeMenu: '/specializedLearning/specialRecord',
          parent: {name: 'specialRecordCo'}
        }
      }]
    },
    {
      path: '/specializedLearning/specialRecord/specialRecordEmp',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/specialRecord/specialRecordEmp'),
      children: [{
        path: '/',
        name: 'specialRecordEmp',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/specialRecord/specialRecordEmp'),
        meta: {
          title: '专项学习记录-学员',
          activeMenu: '/specializedLearning/specialRecord',
          parent: {name: 'specialRecordCo'}
        }
      }]
    },
    {
      path: '/specializedLearning/specialRecord/specialRecordEmpDetail',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/specialRecord/specialRecordEmpDetail'),
      children: [{
        path: '/',
        name: 'specialRecordEmpDetail',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/specialRecord/specialRecordEmpDetail'),
        meta: {
          title: '专项学习记录-学员-详情',
          activeMenu: '/specializedLearning/specialRecord',
          parent: {name: 'specialRecordEmp'}
        }
      }]
    },
    {
      path: '/specializedLearning/specialRecord/specialReportEmp',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/specialRecord/specialReportEmp'),
      children: [{
        path: '/',
        name: 'specialReportEmp',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/specialRecord/specialReportEmp'),
        meta: {
          title: '学习报表-学员',
          activeMenu: '/specializedLearning/specialRecord',
          parent: {name: 'specialRecordEmp'}
        }
      }]
    },
    /**
     *
     *
     * * */

    {
      path: '/specializedLearning/illegalRecord/specialRecordCo',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/illegalRecord/specialRecordCo'),
      children: [{
        path: '/',
        name: 'illegalRecordCo',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/illegalRecord/specialRecordCo'),
        meta: {
          title: '违章学习记录-企业',
          activeMenu: '/illegalLearning/illegalRecord',
          parent: {name: 'illegalRecord'}
        }
      }]
    },
    {
      path: '/specializedLearning/illegalRecord/specialReportCo',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/illegalRecord/specialReportCo'),
      children: [{
        path: '/',
        name: 'illegalReportCo',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/illegalRecord/specialReportCo'),
        meta: {
          title: '学习报表-企业',
          activeMenu: '/illegalLearning/illegalRecord',
          parent: {name: 'illegalRecordCo'}
        }
      }]
    },
    {
      path: '/specializedLearning/illegalRecord/specialRecordEmp',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/illegalRecord/specialRecordEmp'),
      children: [{
        path: '/',
        name: 'illegalRecordEmp',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/illegalRecord/specialRecordEmp'),
        meta: {
          title: '违章学习记录-学员',
          activeMenu: '/illegalLearning/illegalRecord',
          parent: {name: 'illegalRecordCo'}
        }
      }]
    },
    {
      path: '/specializedLearning/illegalRecord/specialRecordEmpDetail',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/illegalRecord/specialRecordEmpDetail'),
      children: [{
        path: '/',
        name: 'illegalRecordEmpDetail',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/illegalRecord/specialRecordEmpDetail'),
        meta: {
          title: '违章学习记录-学员-详情',
          activeMenu: '/illegalLearning/illegalRecord',
          parent: {name: 'illegalRecordEmp'}
        }
      }]
    },
    {
      path: '/specializedLearning/illegalRecord/specialReportEmp',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/illegalRecord/specialReportEmp'),
      children: [{
        path: '/',
        name: 'illegalReportEmp',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/illegalRecord/specialReportEmp'),
        meta: {
          title: '学习报表-学员',
          activeMenu: '/illegalLearning/illegalRecord',
          parent: {name: 'illegalRecordEmp'}
        }
      }]
    },

    {
      path: '/specializedLearning/illegalDetail/unfinish',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/illegalDetail/unfinish'),
      children: [{
        path: '/',
        name: 'unfinish',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/illegalDetail/unfinish'),
        meta: {
          title: '未完成人员',
          activeMenu: '/illegalLearning/illegalDetail',
          parent: {name: 'illegalDetail'}
        }
      }]
    },

    {
      path: '/specializedLearning/illegalDetail/unfinishDetail',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/specializedLearning/illegalDetail/unfinishDetail'),
      children: [{
        path: '/',
        name: 'unfinishDetail',//这个必须和页面name对应起来
        component: () => import('@/views/specializedLearning/illegalDetail/unfinishDetail'),
        meta: {
          title: '未完成人员详情',
          activeMenu: '/illegalLearning/illegalDetail',
          parent: {name: 'unfinish'}
        }
      }]
    },


    // 考试报表
    {
      path: '/examBlock/questionBankManagement/questionBankAdd',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/examBlock/questionBankManagement/questionBankAdd'),
      children: [{
        path: '/',
        name: 'examBlockquestionBankAdd',//这个必须和页面name对应起来
        component: () => import('@/views/examBlock/questionBankManagement/questionBankAdd'),
        meta: {
          title: '考试新增',
          activeMenu: '/examBlock/questionBankManagement',
          parent: {name: 'questionBankManagement'}
        }
      }]
    },

    {
      path: '/examBlock/questionBankManagement/questionBankEdit',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/examBlock/questionBankManagement/questionBankEdit'),
      children: [{
        path: '/',
        name: 'examBlockquestionBankEdit',//这个必须和页面name对应起来
        component: () => import('@/views/examBlock/questionBankManagement/questionBankEdit'),
        meta: {
          title: '考试修改',
          activeMenu: '/examBlock/questionBankManagement',
          parent: {name: 'questionBankManagement'}
        }
      }]
    },
    {
      path: '/examBlock/questionBankManagement/questionBankDetail',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/examBlock/questionBankManagement/questionBankDetail'),
      children: [{
        path: '/',
        name: 'examBlockquestionBankDetail',//这个必须和页面name对应起来
        component: () => import('@/views/examBlock/questionBankManagement/questionBankDetail'),
        meta: {
          title: '考试详情',
          activeMenu: '/examBlock/questionBankManagement',
          parent: {name: 'questionBankManagement'}
        }
      }]
    },



    {
      path: '/examBlock/examReport/examReportDetail',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/examBlock/examReport/examReportDetail'),
      children: [{
        path: '/',
        name: 'examReportDetail',//这个必须和页面name对应起来
        component: () => import('@/views/examBlock/examReport/examReportDetail'),
        meta: {
          title: '考试报表详情',
          activeMenu: '/examBlock/examReport',
          parent: {name: 'examReport'}
        }
      }]
    },

    {
      path: '/examBlock/examManagement/examAdd',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/examBlock/examManagement/examAll'),
      children: [{
        path: '/',
        name: 'examAdd',//这个必须和页面name对应起来
        component: () => import('@/views/examBlock/examManagement/examAll'),
        meta: {
          title: '考试管理新增',
          activeMenu: '/examBlock/examManagement',
          parent: {name: 'examManagement'}
        }
      }]
    },

    {
      path: '/examBlock/examManagement/examEdit',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/examBlock/examManagement/examAll'),
      children: [{
        path: '/',
        name: 'examEdit',//这个必须和页面name对应起来
        component: () => import('@/views/examBlock/examManagement/examAll'),
        meta: {
          title: '考试管理修改',
          activeMenu: '/examBlock/examManagement',
          parent: {name: 'examManagement'}
        }
      }]
    },
    {
      path: '/examBlock/examManagement/examDetail',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/examBlock/examManagement/examAll'),
      children: [{
        path: '/',
        name: 'examDetail',//这个必须和页面name对应起来
        component: () => import('@/views/examBlock/examManagement/examAll'),
        meta: {
          title: '考试管理详情',
          activeMenu: '/examBlock/examManagement',
          parent: {name: 'examManagement'}
        }
      }]
    },


    {
      path: '/examBlock/examManagement/examResult',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/examBlock/examManagement/examResult'),
      children: [{
        path: '/',
        name: 'examResult',//这个必须和页面name对应起来
        component: () => import('@/views/examBlock/examManagement/examResult'),
        meta: {
          title: '考试结果',
          activeMenu: '/examBlock/examManagement',
          parent: {name: 'examManagement'}
        }
      }]
    },

    {
      path: '/examBlock/examManagement/examResultDetail',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/examBlock/examManagement/examResultDetail'),
      children: [{
        path: '/',
        name: 'examResultDetail',//这个必须和页面name对应起来
        component: () => import('@/views/examBlock/examManagement/examResultDetail'),
        meta: {
          title: '考试结果详情',
          activeMenu: '/examBlock/examManagement',
          parent: {name: 'examManagement'}
        }
      }]
    },


    {
      path: '/examBlock/examManagement/examSet',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/examBlock/examManagement/examSet'),
      children: [{
        path: '/',
        name: 'examSet',//这个必须和页面name对应起来
        component: () => import('@/views/examBlock/examManagement/examSet'),
        meta: {
          title: '定期考试设置',
          activeMenu: '/examBlock/examManagement',
          parent: {name: 'examManagement'}
        }
      }]
    },


      {
      path: '/examBlock/examManagement/examPlanAdd',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/examBlock/examManagement/examPlanAll'),
      children: [{
        path: '/',
        name: 'examPlanAdd',//这个必须和页面name对应起来
        component: () => import('@/views/examBlock/examManagement/examPlanAll'),
        meta: {
          title: '定期考试新增',
          activeMenu: '/examBlock/examManagement',
          parent: {name: 'examManagement'}
        }
      }]
    },

    {
      path: '/examBlock/examManagement/examPlanEdit',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/examBlock/examManagement/examPlanAll'),
      children: [{
        path: '/',
        name: 'examPlanEdit',//这个必须和页面name对应起来
        component: () => import('@/views/examBlock/examManagement/examPlanAll'),
        meta: {
          title: '定期考试修改',
          activeMenu: '/examBlock/examManagement',
          parent: {name: 'examManagement'}
        }
      }]
    },
    {
      path: '/examBlock/examManagement/examPlanDetail',
      hidden: true,
      component: Layout, //菜单组件
      component: () => import('@/views/examBlock/examManagement/examPlanAll'),
      children: [{
        path: '/',
        name: 'examPlanDetail',//这个必须和页面name对应起来
        component: () => import('@/views/examBlock/examManagement/examPlanAll'),
        meta: {
          title: '定期考试详情',
          activeMenu: '/examBlock/examManagement',
          parent: {name: 'examManagement'}
        }
      }]
    },

  ]
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  }
]


/**
 * 动态路由
 * asyncRouterMap
 * 菜单路由
 * 默认路由，如果你给首页做权限，没有默认的会出问题，一般正常情况，首页放在静态路由里面
 * 404 访问不到 一般是放在 静态路由最后面，做菜单权限的时候匹配加进去，执行的方法就是router.addRouter()
 */
export const asyncRouterMap = [
  {
    path: '/home',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home', id: "T1", roles: []}
    }]
  },
  {
    path: '/policy',
    component: Layout,
    redirect: '/policy/policy',
    meta: {
      title: '文件及通知',
      icon: 'form',
      id: "T2", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'policy',
        name: 'policy',
        component: () => import('@/views/policy/list/index'),
        meta: {title: '政策管理', id: "T201", roles: [], keepAlive: true}
      },
      {
        path: 'receive',
        name: 'receive',
        component: () => import('@/views/policy/receive/index'),
        meta: {title: '收到的政策', id: "T202", roles: []}
      }
    ]
  },
  {
    path: '/cost',
    component: Layout,
    redirect: '/cost/unitPrice',
    meta: {
      title: '费用管理',
      icon: 'money',
      id: "T3", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'unitPrice',
        name: 'unitPrice',
        component: () => import('@/views/cost/unitPrice/index'),
        meta: {title: '个体价格设置', id: "T301", roles: []}
      },
      {
        path: 'price',
        name: 'price',
        component: () => import('@/views/cost/price/index'),
        meta: {title: '企业价格设置', id: "T303", roles: []}
      },
      {
        path: 'expire',
        name: 'expire',
        component: () => import('@/views/cost/expire/index'),
        meta: {title: '到期提醒设置', id: "T302", roles: []}
      },
      {
        path: 'renew',
        name: 'renew',
        component: () => import('@/views/cost/renew/index'),
        meta: {title: '缴费管理', id: "T304", roles: []}
      },
      {
        path: 'apply',
        name: 'apply',
        component: () => import('@/views/cost/apply/index'),
        meta: {title: '功能开通申请', id: "T305", roles: []}
      },
      {
        path: 'transaction',
        name: 'transaction',
        component: () => import('@/views/cost/transaction/index'),
        meta: {title: '交易记录', id: "T306", roles: []}
      },
      {
        path: 'recharge',
        name: 'recharge',
        component: () => import('@/views/cost/recharge/index'),
        meta: {title: '充值记录', id: "T307", roles: []}
      }
    ]
  },
  {
    path: '/trainBasic',
    component: Layout,
    redirect: '/trainBasic/classify',
    meta: {
      title: '培训基础数据管理',
      icon: 'file',
      id: "T4", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'classify',
        name: 'classify',
        component: () => import('@/views/trainBasic/classify/index'),
        meta: {title: '培训类型', id: "T401", roles: []}
      },
      {
        path: 'courseware',
        name: 'courseware',
        component: () => import('@/views/trainBasic/courseware/index'),
        meta: {title: '课件库', id: "T402", roles: [], keepAlive: true}
      },
      {
        path: 'course',
        name: 'course',
        component: () => import('@/views/trainBasic/course/index'),
        meta: {title: '培训课程', id: "T403", roles: [], keepAlive: true}
      },
      {
        path: 'questionBank',
        name: 'questionBank',
        component: () => import('@/views/trainBasic/questionBank/index'),
        meta: {title: '题库', id: "T404", roles: [], keepAlive: true}
      }
    ]
  },
  {
    path: '/examBlock',
    component: Layout,
    redirect: '/examBlock/topicType',
    meta: {
      title: '考试板块',
      icon: 'safety',
      id: "T19", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'topicType',
        name: 'topicType',
        component: () => import('@/views/examBlock/topicType/index'),
        meta: {title: '题目类型', id: "T1901", roles: [], keepAlive: true}
      },
      {
        path: 'questionBankManagement',
        name: 'questionBankManagement',
        component: () => import('@/views/examBlock/questionBankManagement/index'),
        meta: {title: '题库管理', id: "T1902", roles: [], keepAlive: true}
      },
      {
        path: 'examManagement',
        name: 'examManagement',
        component: () => import('@/views/examBlock/examManagement/index'),
        meta: {title: '考试管理', id: "T1903", roles: [], keepAlive: true}
      },
      {
        path: 'examReport',
        name: 'examReport',
        component: () => import('@/views/examBlock/examReport/index'),
        meta: {title: '考试报表', id: "T1904", roles: [], keepAlive: true},
      },

    ]
  },
  {
    path: '/safety',
    component: Layout,
    redirect: '/safety/plan',
    meta: {
      title: '安全培训',
      icon: 'safety',
      id: "T5", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'plan',
        name: 'plan',
        component: () => import('@/views/safety/plan/index'),
        meta: {title: '培训计划', id: "T501", roles: [], keepAlive: true}
      },
      {
        path: 'report',
        name: 'report',
        component: () => import('@/views/safety/report/index'),
        meta: {title: '学习报表', id: "T502", roles: [], keepAlive: true}
      },
      {
        path: 'train',
        name: 'train',
        component: () => import('@/views/safety/train/index'),
        meta: {title: '企业培训状况', id: "T503", roles: [], keepAlive: true}
      },
      {
        path: 'offline',
        name: 'offline',
        component: () => import('@/views/safety/offline/index'),
        meta: {title: '线下培训管理', id: "T504", roles: [], keepAlive: true}
      },
      {
        path: 'examine',
        name: 'examine',
        component: () => import('@/views/safety/examine/index'),
        meta: {title: '考试报表', id: "T505", roles: [], keepAlive: true}
      },
      {
        path: 'trainingSyllabus',
        name: 'trainingSyllabus',
        component: () => import('@/views/safety/trainingSyllabus/index'),
        meta: {title: '培训大纲', id: "T506", roles: [], keepAlive: true}
      },
      {
        path: 'periodRecord',
        name: 'periodRecord',
        component: () => import('@/views/authority/periodRecord/index'),
        meta: {title: '推送学习记录', id: "T909", roles: []}
      },
    ]
  },
  {
    path: '/preTraining',
    component: Layout,
    redirect: '/preTraining/curriculum',
    meta: {
      title: '岗前培训',
      icon: 'train',
      id: "T6", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'curriculum',
        name: 'curriculum',
        component: () => import('@/views/preTraining/curriculum/index'),
        meta: {title: '课程设置', id: "T601", roles: [], keepAlive: true}
      },
      {
        path: 'preRecord',
        name: 'preRecord',
        component: () => import('@/views/preTraining/preRecord/index'),
        meta: {title: '岗前培训记录', id: "T602", roles: [], keepAlive: true}
      }
    ]
  },
  {
    path: '/specializedLearning',
    component: Layout,
    redirect: '/specializedLearning/specializedLearning',
    meta: {
      title: '专项学习',
      icon: 'train',
      id: "T500", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'specializedLearning',
        name: 'specializedLearning',
        component: () => import('@/views/specializedLearning/specializedLearning/index'),
        meta: {title: '专项学习管理', id: "T5002", roles: [], keepAlive: true}
      },
      {
        path: 'specialRecord',
        name: 'specialRecord',
        component: () => import('@/views/specializedLearning/specialRecord/index'),
        meta: {title: '专项学习记录', id: "T5003", roles: [], keepAlive: true}
      },
    ]
  },

  {
    path: '/illegalLearning',
    component: Layout,
    redirect: '/specializedLearning/illegalLearning',
    meta: {
      title: '违章学习',
      icon: 'train',
      id: "T600", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'illegalLearning',
        name: 'illegalLearning',
        component: () => import('@/views/specializedLearning/illegalLearning/index'),
        meta: {title: '违章学习', id: "T6002", roles: [], keepAlive: true}
      },
      {
        path: 'illegalRecord',
        name: 'illegalRecord',
        component: () => import('@/views/specializedLearning/illegalRecord/index'),
        meta: {title: '违章学习记录', id: "T6003", roles: [], keepAlive: true}
      },
      {
        path: 'illegalDetail',
        name: 'illegalDetail',
        component: () => import('@/views/specializedLearning/illegalDetail/index'),
        meta: {title: '违章学习详情', id: "T6004", roles: [], keepAlive: true}
      },
    ]
  },
  {
    path: '/examEmployees',
    component: Layout,
    redirect: '/examEmployees/questionBankManagement',
    meta: {
      title: '从业人员资格证考试模拟',
      icon: 'safety',
      id: "T23", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'questionBankManagementEmp',
        name: 'questionBankManagementEmp',
        component: () => import('@/views/examEmployees/questionBankManagement/index'),
        meta: {title: '试题库管理', id: "T2301", roles: [], keepAlive: true}
      }
    ]
  },
  {
    path: '/towStaffTestQuestions',
    component: Layout,
    redirect: '/towStaffTestQuestions/testQuestions',
    meta: {
      title: '两类人员安全考试模拟题',
      icon: 'questions',
      id: "T11", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'testQuestions',
        name: 'testQuestions',
        component: () => import('@/views/towStaffTestQuestions/testQuestions/index'),
        meta: {title: '试题库管理', id: "T1101", roles: [], keepAlive: true}
      }
    ]
  },
  {
    path: '/evaluation',
    component: Layout,
    redirect: '/evaluation/platformEvaluation',
    meta: {
      title: '评价管理',
      icon: 'evaluation',
      id: "T12", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'platformEvaluation',
        name: 'platformEvaluation',
        component: () => import('@/views/evaluation/platform/index'),
        meta: {title: '平台评价管理', id: "T1201", roles: []}
      },
      {
        path: 'coursewareEvaluation',
        name: 'coursewareEvaluation',
        component: () => import('@/views/evaluation/courseware/index'),
        meta: {title: '课件评价管理', id: "T1202", roles: []}
      }
    ]
  },
  {
    path: '/askQuestions',
    component: Layout,
    redirect: '/askQuestions',
    children: [{
      path: '/askQuestions',
      name: 'askQuestions',
      component: () => import('@/views/askQuestions/index'),
      meta: {title: '提问管理', icon: 'ask', id: "T13", roles: []}
    }]
  },
  {
    path: '/msg',
    component: Layout,
    redirect: '/msg',
    children: [{
      path: '/msg',
      name: 'msg',
      component: () => import('@/views/msg/index'),
      meta: {title: '消息管理', icon: 'message', id: "T7", roles: [], keepAlive: true}
    }]
  },
  {
    path: '/information',
    component: Layout,
    redirect: '/information',
    meta: {
      title: '资讯管理',
      icon: 'info',
      id: "T10086", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'informationCategory',
        name: 'informationCategory',
        component: () => import('@/views/information/informationCategory/index'),
        meta: {title: '资讯分类', icon: 'info', id: "T1008601", roles: []}

      },{
      path: 'informationContent',
      name: 'informationContent',
      component: () => import('@/views/information/index'),
      meta: {title: '资讯内容', icon: 'info', id: "T18", roles: []}
    },  {
      path: 'informationEvaluation',
      name: 'informationEvaluation',
      component: () => import('@/views/information/evaluation/index'),
      meta: {title: '资讯评论管理', icon: 'info', id: "T1008602", roles: []}

    }
  ]
  },
  {
    path: '/basic',
    component: Layout,
    redirect: '/basic/issuingAuthority',
    meta: {
      title: '基础数据管理',
      icon: 'clipboard',
      id: "T8", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'issuingAuthority',
        name: 'issuingAuthority',
        component: () => import('@/views/basic/issuingAuthority/index'),
        meta: {title: '发证机关', id: "T801", roles: []}
      }
    ]
  },
  {
    path: '/contract',
    component: Layout,
    redirect: '/contract',
    meta: {
      title: '合同协议管理',
      icon: 'contract',
      id: "T15", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'issuedDocTypes',
        name: 'issuedDocTypes',
        component: () => import('@/views/contract/issuedDocTypes/index'),
        meta: {title: '下发文件类别管理', id: "T1501", roles: []}
      },
      {
        path: 'signature',
        name: 'signature',
        component: () => import('@/views/contract/signature/index'),
        meta: {title: '签章管理', id: "T1502", roles: []}
      },
      {
        path: 'sign',
        name: 'sign',
        component: () => import('@/views/contract/sign/index'),
        meta: {title: '签名管理', id: "T1503", roles: []}
      },
      {
        path: 'contract',
        name: 'contract',
        component: () => import('@/views/contract/list/index'),
        meta: {title: '合同协议', id: "T1504", roles: [], keepAlive: true}
      }]
  },
  {
    path: '/approve',
    component: Layout,
    redirect: '/approve',
    meta: {
      title: '审批流程管理',
      icon: 'approve',
      id: "T17", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'setProcess',
        name: 'setProcess',
        component: () => import('@/views/approve/setProcess'),
        meta: {title: '设置审批流程', id: "T1701", roles: [], keepAlive: true}
      },
      {
        path: 'processReview',
        name: 'processReview',
        component: () => import('@/views/approve/processReview'),
        meta: {title: '流程审核', id: "T1702", roles: [], keepAlive: true}
      },
      {
        path: 'approvalRecord',
        name: 'approvalRecord',
        component: () => import('@/views/approve/approvalRecord'),
        meta: {title: '审批记录', id: "T1703", roles: [], keepAlive: true}
      },
    ]
  },
  {
    path: '/finance',
    component: Layout,
    redirect: '/finance/pay',
    meta: {
      title: '财务板块',
      icon: 'finance',
      id: "T16", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'pay',
        name: 'pay',
        component: () => import('@/views/finance/pay'),
        meta: {title: '缴费记录', id: "T1601", roles: []}
      },
      {
        path: 'received',
        name: 'received',
        component: () => import('@/views/finance/received'),
        meta: {title: '已收充值', id: "T1602", roles: []}
      },
      {
        path: 'receivable',
        name: 'receivable',
        component: () => import('@/views/finance/receivable'),
        meta: {title: '应收充值', id: "T1603", roles: []}
      },
      {
        path: 'presentation',
        name: 'presentation',
        component: () => import('@/views/finance/presentation'),
        meta: {title: '赠送充值', id: "T1604", roles: []}
      },
      {
        path: 'internalTest',
        name: 'internalTest',
        component: () => import('@/views/finance/internalTest'),
        meta: {title: '内部测试充值', id: "T1605", roles: []}
      },
      {
        path: 'open',
        name: 'open',
        component: () => import('@/views/finance/open'),
        meta: {title: '开通记录管理', id: "T1606", roles: [], keepAlive: true}
      },
    ]
  },
  {
    path: '/authority',
    component: Layout,
    redirect: '/authority/industry',
    meta: {
      title: '权限管理',
      icon: 'tree',
      id: "T9", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'industry',
        name: 'industry',
        component: () => import('@/views/authority/industry/index'),
        meta: {title: '行政区域管理', id: "T901", roles: []}
      },
      {
        path: 'enterprise',
        name: 'enterprise',
        component: () => import('@/views/authority/enterprise/index'),
        meta: {title: '企业管理', id: "T902", roles: [], keepAlive: true}
      },
      {
        path: 'enpAccount',
        name: 'enpAccount',
        component: () => import('@/views/authority/enpAccount/index'),
        meta: {title: '企业管理员账号管理', id: "T903", roles: [], keepAlive: true}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/authority/role/index'),
        meta: {title: '角色管理', id: "T904", roles: []}
      },
      {
        path: 'account',
        name: 'account',
        component: () => import('@/views/authority/account/index'),
        meta: {title: '账号管理', id: "T905", roles: [], keepAlive: true}
      },
      {
        path: 'platformAccount',
        name: 'platformAccount',
        component: () => import('@/views/authority/platformAccount/index'),
        meta: {title: '平台账号管理', id: "T908", roles: []}
      },
      {
        path: 'car',
        name: 'car',
        component: () => import('@/views/authority/car/index'),
        meta: {title: '车辆管理', id: "T906", roles: [], keepAlive: true}
      },
      {
        path: 'noPlay',
        name: 'noPlay',
        component: () => import('@/views/authority/noPlay/index'),
        meta: {title: '无交互设置', id: "T907", roles: []}
      },
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/set',
    meta: {
      title: '系统管理',
      icon: 'set',
      id: "T10", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'colSet',
        name: 'colSet',
        component: () => import('@/views/system/colSet/index'),
        meta: {title: '企业设置', id: "T1008", roles: []}
      },
      {
        path: 'set',
        name: 'set',
        component: () => import('@/views/system/set/index'),
        meta: {title: '设置', id: "T1001", roles: []}
      },
      {
        path: 'privacy',
        name: 'privacy',
        component: () => import('@/views/system/privacy'),
        meta: {title: '用户协议与隐私政策', id: "T1002", roles: []}
      },
      {
        path: 'floating',
        name: 'floating',
        component: () => import('@/views/system/floating/index'),
        meta: {title: '浮窗侧边栏管理', id: "T1003", roles: []}
      },
      {
        path: 'app',
        name: 'app',
        component: () => import('@/views/system/app/index'),
        meta: {title: 'APP版本控制', id: "T1004", roles: []}
      },
      {
        path: 'banner',
        name: 'banner',
        component: () => import('@/views/system/banner/index'),
        meta: {title: 'Banner图设置', id: "T1005", roles: []}
      },
      {
        path: 'complaint',
        name: 'complaint',
        component: () => import('@/views/system/complaint/index'),
        meta: {title: '投诉反馈', id: "T1006", roles: []}
      },
      {
        path: 'log',
        name: 'log',
        component: () => import('@/views/system/log'),
        meta: {title: '日志记录', id: "T1007", roles: []}
      }
    ]
  },
  {
    path: '/dataStatisticalAnalysis',
    component: Layout,
    redirect: '/dataStatisticalAnalysis/statisticalAnalysis',
    meta: {
      title: '数据统计分析',
      icon: 'set',
      id: "T20", roles: []
    },
    alwaysShow: true, //当有二级菜单的时候使用
    children: [
      {
        path: 'statisticalAnalysis',
        name: 'statisticalAnalysis',
        component: () => import('@/views/dataStatisticalAnalysis/statisticalAnalysis/index'),
        meta: {title: '统计分析', id: "T2001", roles: []}
      },
    ]
  },
  // 404页必须放在末尾！！！
  {path: '*', redirect: '/404', hidden: true}
]

const createRouter = () => new Router({
  // mode:'hash',//需要服务支持
  scrollBehavior: () => ({y: 0}),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
